import React, { useRef, useState } from "react";
import "./css/TopBar.css";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { StatusIcon } from "./assets/svgs";
import { ChangeCustomerStatusCustomerProfile } from "./components/change_customer_status/change_customer_status";
import { Toast } from "primereact/toast";
import { AssignLabel } from "./AssignLabel/AssignLabel/AssignLabel";
import { AssignLabelNew } from "./AssignLabelNew/AssignLabel/AssignLabel";
import { ESIMProfileDialog } from "./components/ESIMProfileDialog/ESIMProfileDialog";
import { api } from "../../../../../../../utility/AxiosInceptor";
import CommonLoaderBlue from "../../../../../../components/Loader/LoaderBlue";
const TopBarCustomerProfile = ({
  setServiceInfoApiCalled,
  setSelectedId,
  setRefreshCustomerData,
  cpData,
  isServiceInfoApiCalled,
  setCurrentSelectedTab,
  currentSelectedTab,
  setChangeCustomerStatus,
  changeCustomerStatusDialog,
}) => {
  const [visible, setVisible] = useState(false);
  const [esimQrVisible, setEsimQrVisible] = useState(false);
  const [isLabelDownloadLoading, setIsLabelDownloadLoading] = useState(false);
  const [isTrackingLoading, setIsTrackingLoading] = useState(false);

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const downloadLabel = async () => {
    try {
      setIsLabelDownloadLoading(true);

      const path = cpData?.label;
      const trimmedPath = path.replace(/^uploads\//, "");
      const fileUrl = `${BASE_URL}/${trimmedPath}`;

      // Fetch PDF as blob
      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
          Accept: "application/pdf",
        },
      });

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create download link
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `label_accountId${cpData.accountId}.pdf`); // 👈 Forces download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading label:", error);
    } finally {
      setIsLabelDownloadLoading(false);
    }
  };

  const handleTrackingPackage = async () => {
    setIsTrackingLoading(true);
    try {
      const response = await api.get(
        `/api/web/order/getTrackingNumber/?customerId=${cpData._id}`,
      );
      const data = response?.data?.data;
      if (data) {
        const trackingId = data;
        const trackingUrl = `https://tools.usps.com/go/TrackConfirmAction?&tLabels=${trackingId}`;
        window.open(trackingUrl, "_blank");
      } else {
      }
      setIsTrackingLoading(false);
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Tracking Package",
        detail: error?.response?.data?.msg,
        life: 3000,
      });
      setIsTrackingLoading(false);
    }
  };
  const [assignLabelVisible, setAssignLabelVisible] = useState(false);
  let model = JSON.parse(localStorage.getItem("permissions"));
  const toast = useRef();
  const navigate = useNavigate();
  return (
    <div className="main-customerprofile-topmost-container ">
      <div className="main-customer-topbarconatiner">
        <div className="main-left-topbar">
          <div
            className={`main-status-container align-items-center flex flex-wrap flex-row ${cpData?.status ? "justify-content-start" : "justify-content-center"} ${cpData.status === "rejected" ? "status-rejected" : cpData.status === "active" ? "status-active" : cpData.status === "inactive" ? "status-inactive" : cpData.status === "prospect" ? "status-prospected" : cpData.status === "suspended" ? "status-suspended" : cpData.status === "disconnected" ? "status-disconnected" : cpData.status === "cancelled" ? "status-cancelled" : "status-prospected"}`}
            onClick={async () => {
              if (cpData?.status !== "rejected") {
                setChangeCustomerStatus(true);
              }
            }}
          >
            {" "}
            {cpData?.status ? (
              <>
                <StatusIcon />

                <p
                  onClick={() => {
                    if (cpData?.status !== "rejected") {
                      setChangeCustomerStatus(true);
                    }
                  }}
                >
                  {cpData?.status === "prospect"
                    ? "Prospect"
                    : cpData.status === "disconnected"
                      ? "Disconnected"
                      : cpData.status === "active"
                        ? "Active"
                        : cpData.status === "inActive"
                          ? "InActive"
                          : cpData.status === "rejected"
                            ? "Rejected"
                            : cpData.status === "cancelled"
                              ? "Cancelled"
                              : cpData.status === "suspended"
                                ? "Suspended"
                                : ""}
                </p>
              </>
            ) : (
              <CommonLoaderBlue sizehere={13} color="royalblue" />
            )}
          </div>
          <p className="customer-name">
            {cpData?.firstName !== "" &&
            cpData?.firstName !== undefined &&
            cpData?.lastName !== "" &&
            cpData?.lastName !== undefined
              ? cpData?.firstName + " " + cpData?.lastName
              : cpData?.firstName}
          </p>
          <div className="bottom-topbar-customerdetails">
            <div className="accounts-details">
              <p>
                Account Id:&nbsp;&nbsp;
                <span>{cpData.accountId ? cpData.accountId : "Nil"}</span>
              </p>
              <p>
                MDN:&nbsp;&nbsp;
                <span>{cpData.phoneNumber ? cpData.phoneNumber : "Nil"}</span>
              </p>
              {cpData?.linkedAccount && (
                <p
                  onClick={() => {
                    setServiceInfoApiCalled(false);
                    localStorage.removeItem("selectedId");
                    localStorage.setItem(
                      "selectedId",
                      JSON.stringify(cpData.parent_id),
                    );
                    setSelectedId(cpData?.parent_id);

                    setRefreshCustomerData((prev) => !prev);
                    setCurrentSelectedTab("customer-profile");
                  }}
                  className="parent-account-link"
                >
                  Parent Account
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="main-right-topbar">
          <Button
            onClick={() => {
              navigate("/add-service");
            }}
            disabled={
              !cpData ||
              Object.keys(cpData).length === 0 || // disable if cpData is empty
              cpData?.linkedAccount ||
              !model.some((element) =>
                element.subModules.some(
                  (subModule) => subModule.subModuleName === "Add Services",
                ),
              )
            }
            type="button"
            className="addservicebutton"
            label="Add Services"
          />
        </div>
      </div>
      <div className="tabbar">
        <div className="tab-main">
          <p
            className={`${currentSelectedTab === "customer-profile" ? "selectedtab" : ""}`}
            onClick={() => {
              setCurrentSelectedTab("customer-profile");
            }}
          >
            Customer Info
          </p>
          <p
            className={`${currentSelectedTab === "line-info" ? "selectedtab" : ""}`}
            onClick={() => {
              setCurrentSelectedTab("line-info");
            }}
          >
            Line Info
          </p>
          <p
            className={`${currentSelectedTab === "other-info" ? "selectedtab" : ""}`}
            onClick={() => {
              setCurrentSelectedTab("other-info");
            }}
          >
            Other Info{" "}
          </p>
          {model.some((element) =>
            element.subModules.some(
              (subModule) => subModule.subModuleName === "Billing And Invoice",
            ),
          ) && (
            <p
              className={`flex flex-wrap flex-row justify-center items-center ${currentSelectedTab === "payment" ? "selectedtab" : ""}`}
              onClick={() => {
                setCurrentSelectedTab("payment");
              }}
            >
              <span>Payment</span>
              <span>00</span>
            </p>
          )}
          <p
            className={`${currentSelectedTab === "wallet" ? "selectedtab" : ""}`}
            onClick={() => {
              setCurrentSelectedTab("wallet");
            }}
          >
            Wallet
          </p>
          {model.some((element) =>
            element.subModules.some(
              (subModule) => subModule.subModuleName === "Files",
            ),
          ) && (
            <p
              className={`${currentSelectedTab === "files" ? "selectedtab" : ""}`}
              onClick={() => {
                setCurrentSelectedTab("files");
              }}
            >
              Files
            </p>
          )}
          {model.some((element) =>
            element.subModules.some(
              (subModule) => subModule.subModuleName === "Usage",
            ),
          ) && (
            <p
              className={`${currentSelectedTab === "usage" ? "selectedtab" : ""}`}
              onClick={() => {
                setCurrentSelectedTab("usage");
              }}
            >
              Usage
            </p>
          )}
          {(model.some((element) =>
            element.subModules.some(
              (subModule) => subModule.subModuleName === "Query Network",
            ),
          ) ||
            model.some((element) =>
              element.subModules.some(
                (subModule) => subModule.subModuleName === "Query Sim",
              ),
            ) ||
            model.some((element) =>
              element.subModules.some(
                (subModule) => subModule.subModuleName === "Imei Validation",
              ),
            )) && (
            <p
              className={`${currentSelectedTab === "quick-links" ? "selectedtab" : ""}`}
              onClick={() => {
                setCurrentSelectedTab("quick-links");
              }}
            >
              Quick Links
            </p>
          )}
          {!cpData?.linkedAccount &&
            model.some((element) =>
              element.subModules.some(
                (subModule) => subModule.subModuleName === "Linked Accounts",
              ),
            ) && (
              <p
                className={`flex flex-wrap flex-row justify-center items-center ${currentSelectedTab === "child-accounts" ? "selectedtab" : ""}`}
                onClick={() => {
                  setCurrentSelectedTab("child-accounts");
                }}
              >
                <span>Child Accounts</span>
              </p>
            )}
        </div>
        {cpData?.esn !== undefined &&
          cpData?.label === undefined &&
          cpData?.isEnrollmentComplete &&
          (cpData?.accountType === "Prepaid" ||
            cpData?.accountType === "Postpaid") &&
          cpData?.accountType !== "ACP" &&
          !cpData?.AcptoPrepaid && (
            <Button
              onClick={() => {
                setAssignLabelVisible(true);
                //setAssignType("Label");
              }}
              type="button"
              className="assignlabelbtn"
              label="Assign Label"
            />
          )}
        {cpData.label && (
          <Button
            onClick={() => downloadLabel()}
            style={{ width: "12rem" }}
            type="button"
            disabled={isLabelDownloadLoading}
            className="btn"
            label="Download Label"
            icon={isLabelDownloadLoading ? "pi pi-spin pi-spinner " : ""}
          />
        )}
        {cpData.label && (
          <Button
            onClick={() => handleTrackingPackage()}
            type="button"
            className="btn"
            style={{ width: "12rem" }}
            disabled={isTrackingLoading}
            label="Track Package"
            icon={isTrackingLoading === true ? "pi pi-spin pi-spinner " : ""}
          />
        )}
        {cpData?.esn === undefined &&
          cpData?.isEnrollmentComplete &&
          (cpData?.accountType === "Prepaid" ||
            cpData?.accountType === "Postpaid") &&
          cpData?.accountType !== "ACP" &&
          !cpData?.AcptoPrepaid && (
            <Button
              onClick={() => {
                setVisible(true);
                //setAssignType("Label");
              }}
              type="button"
              className="assignlabelbtn"
              label="Assign ESN"
            />
          )}
      </div>

      {visible && (
        <AssignLabel
          setRefreshCustomerData={setRefreshCustomerData}
          cpData={cpData}
          toast={toast}
          setVisible={setVisible}
        />
      )}
      {assignLabelVisible && (
        <AssignLabelNew
          toast={toast}
          setRefreshCustomerData={setRefreshCustomerData}
          cpData={cpData}
          setVisible={setAssignLabelVisible}
        />
      )}
      {esimQrVisible && (
        <ESIMProfileDialog
          toast={toast}
          cpData={cpData}
          setVisible={setEsimQrVisible}
        />
      )}
      {changeCustomerStatusDialog && (
        <div className="customer-status-main-main">
          <ChangeCustomerStatusCustomerProfile
            setRefreshCustomerData={setRefreshCustomerData}
            cpData={cpData}
            toast={toast}
            setServiceInfoApiCalled={setServiceInfoApiCalled}
            setChangeCustomerStatus={setChangeCustomerStatus}
          />
        </div>
      )}
      <Toast ref={toast} />
    </div>
  );
};

export default TopBarCustomerProfile;
